// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1E2VR","box":"WorkspacesBox_box__1LKT4","node":"WorkspacesBox_node__raKI4"};